import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';

import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import loading from "../../assets/images/loading.gif"
import { makeGetRequest, makePatchRequest } from "../../request";
import { useDispatch } from "react-redux";
import { formatDateTime } from "../../helpers";
import Pagination from "../../components/Pagination";
import Layout from "../Layout";
import { MRDInfo, SelectedMRD } from "../../interfaces/materialreadinessdocument.types";
import { setPageContext } from "store/pageContext";

const BatchAssignMaterialReadinessDocuments =  () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const params = useParams()
    const [materialReadinessDocuments, setMaterialReadinessDocuments] = useState<MRDInfo[]>()
    const [mrdNumber, setMrdNumber] = useState("")
    const [selectedMRDs, setSelectedMRDs] = useState<SelectedMRD[]>([])

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };

    const handleCheck = (e:React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target
        if(checked){
            const item: any = materialReadinessDocuments?.find((item) => item.id === value)
            const selectedItem: any = {
                id: item?.id,
                mrdNumber: item?.mrdNumber,
                createdDate: item?.createdDate,
                pickUpAddress: item?.pickUpAddress,
                totalBatchedPOs: item?.commercialInvoices.length,
                countryOfSupply: item?.countryOfSupply,
                destination: item?.destination,
                rowVersion: item?.rowVersion
            }
            setSelectedMRDs([...selectedMRDs, selectedItem])
        }else {
            var remainingItems = selectedMRDs.filter((item:any) => item.id !== value)
            setSelectedMRDs(remainingItems)
        }
    }

    const handleCheckAll = (e:React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target
        if(checked){
            const items:any = materialReadinessDocuments?.map((item:any) => ({                
                    id: item?.id,
                    mrdNumber: item?.mrdNumber,
                    createdDate: item?.createdDate,
                    pickUpAddress: item?.pickUpAddress,
                    totalBatchedPOs: item?.commercialInvoices.length,
                    countryOfSupply: item?.countryOfSupply,
                    destination: item?.destination,   
                    rowVersion: item?.rowVersion         
                }));

            setSelectedMRDs(items);
            
        }else setSelectedMRDs([])
    }

    const row = materialReadinessDocuments?.map((data, i) => {
        return (
            <tr key={i}>
                <td>
                    <input 
                    type="checkbox" 
                    value={data.id} 
                    onChange={handleCheck} 
                    checked={!!selectedMRDs.find(item => item.id === data.id)} />
                </td>
                <td>{ currentPage === 1 ? currentPage + i : (((itemsPerPage*currentPage)-itemsPerPage)+1) + i }</td>
                <td>{ data.mrdNumber }</td>
                <td>{ formatDateTime(data.createdDate) }</td>
                {/* <td>{ data?.pickUpAddress }</td> */}
                <td>{ data?.countryOfSupply }</td>
                <td>{ data?.commercialInvoices.length }</td>
                <td>{ data?.destination }</td>
                <td>
                    <div className="actions" onClick={() => {navigate("/shippingofficer/materialreadinessdocument/"+data.id); 
                        dispatch(setPageContext({page: "Freight Forwarders", 
                                                url: `/shippingofficer/batch-assign-material-readiness-documents/${user.email}`,
                                                view: "Batch Assign ",
                                                companyName: user.companyName,
                                                id: user.id}))}}>
                        <span className="material-symbols-rounded">pageview</span>
                        <span>View Details</span>
                    </div>
                </td>
            </tr>
        )
    })

    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState<Record <string, any>>([])
    const getUser = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getUserByEmail",
            params: {
                Email: params.email
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data.user
                setUser(res)
            })
            .catch((error:any) => 
                {toast.error(error); setIsLoading(false)}
            );
    }

    const getMaterialReadinessDocuments = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getMRDs",
            params: {
                page: currentPage,
                pageSize: itemsPerPage,
                status: 1, //get unassigned mrds
                OrderBy: 2,
                FreightForwarder: true
            }
        };
        if(mrdNumber) request.params.SearchString = mrdNumber
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data
                setMaterialReadinessDocuments(res.data)
                setTotalItems(res.totalCount)
            })
            .catch((error:any) => 
                {toast.error(error); setIsLoading(false)}
            );
    }

    const [isSubmitting, setIsSubmitting] = useState(false)
    
    const HandleBatchAssignMaterialReadinessDocuments = () => {
        setIsLoading(true)
        const selectedMRDDetails = selectedMRDs.map((data: any) => ({
            materialReadinessDocumentId: data.id,
            rowVersion: data.rowVersion
        }))
        var request: Record<string, any> = {
            what: "BatchAssignMaterialReadinessDocuments",
            data: {
                userId: user?.id,
                materialReadiness: selectedMRDDetails
            }
        };
        
        if(!selectedMRDs.length) toast.warning("Atleast one Material Readiness Document must be selected.")
        else {
            setIsSubmitting(true)
            makePatchRequest(request)
                .then((response: any) => {
                    setIsSubmitting(true)
                    setIsLoading(false)
                    toast.success(response.msg)

                    setTimeout(() => {
                        navigate("/shippingofficer/freightforwarders")
                    }, 2000);                    
                })
                .catch((error:any) => {toast.error(error.errorMessage); setIsLoading(false)});
        }
    }

    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setMrdNumber("")
    }

    useEffect(() => {
        getUser(); 
        getMaterialReadinessDocuments()
        // eslint-disable-next-line
    }, [mrdNumber, currentPage, itemsPerPage])

    const page = "Freight Forwarder Assignment"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main mt-2">
                    <div className="main-inner">                  
                        <div className="detail-top-section">
                            <div className="d-flex">
                                <Link to={"/shippingofficer/freightforwarders"} className="actions">
                                    <p><span className="material-symbols-rounded">arrow_back</span> Back to Freight Forwarders</p>
                                </Link>

                                <p style={{color: "#3e3e3e"}}><span className="material-symbols-rounded">account_circle</span>{ user?.companyName }</p>
                            </div>  
                            <div className="tab">
                                <div className="tab-item active">
                                    <span className="material-symbols-rounded">assignment_add</span>
                                    <p>Batch Assign Material Readiness Documents</p>
                                </div>
                            </div>                      
                        </div>                        
                    </div>
                    <div className="main-inner mt-1">  
                        
                        <div className="d-flex-center" style={{padding: "16px"}}>
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="mrdnumber" placeholder="Search MRD Number" style={{height: "20px"}} onKeyUp={handleSearch} />
                                </div>
                                <button 
                                    onClick={() => setMrdNumber((document.getElementById("mrdnumber") as HTMLInputElement)?.value)} 
                                    className="custom-button orange left-item ml-2">Search</button>
                            </div>
                        </div> 
                        <div className={`alert alert-info`} style={{margin: "16px", marginTop: "0", padding: "8px", width: "auto"}}>
                            <span className="material-symbols-outlined mr-2 text-blue" style={{fontSize: "16px"}}>info</span>
                            <p style={{margin: 0}}>Prior to assignment, kindly confirm that ALL unassigned material readiness documents have a consignee and destination plant. <br/> Documents missing this information would not be listed below for assignment.</p>
                        </div> 
                        <div className='table-container custom' style={{minHeight: "calc(100vh - 160px)"}}>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th><input type="checkbox" onChange={handleCheckAll} /></th>
                                        <th>SN</th>
                                        <th>MRD Number</th>
                                        <th>Issuance Date</th>
                                        <th>Country of Supply</th>
                                        <th>Total Batched POs</th>
                                        <th>Destination</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                                materialReadinessDocuments?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                                : row
                                            )
                                        }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                            startIndex={startIndex} />
                        </div>
                    </div>
                    

                    <div className="main-inner">                 
                        <p style={{padding: "12px 0 0 12px", marginTop: "8px", fontSize: "12px"}}><span className="errorX mr-2">*</span>Selected Material Readiness Documents</p>
                        <div className='table-container custom' style={{minHeight: "calc(100vh - 160px)"}}>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th></th>
                                        <th>SN</th>
                                        <th>MRD Number</th>
                                        <th>Issuance Date</th>
                                        {/* <th>Pickup Address</th> */}
                                        <th>Country of Supply</th>
                                        <th>Total Batched POs</th>
                                        <th>Destination</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        selectedMRDs?.map((data, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>
                                                        <input type="checkbox" value={data.id} 
                                                        onChange={handleCheck} 
                                                        checked={!!selectedMRDs.find(item => item.id === data.id)}/>
                                                    </td>
                                                    <td>{ currentPage === 1 ? currentPage + i : (((itemsPerPage*currentPage)-itemsPerPage)+1) + i }</td>
                                                    <td>{ data.mrdNumber }</td>
                                                    <td>{ formatDateTime(data.createdDate) }</td>
                                                    {/* <td>{ data?.pickUpAddress }</td> */}
                                                    <td>{ data?.countryOfSupply }</td>
                                                    <td>{ data?.totalBatchedPOs }</td>
                                                    <td>{ data?.destination }</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            {false ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                    </div>   

                    <div className="main-inner mt-1" style={{padding: "16px 0"}}>                 
                        <button type="submit" className="custom-button orange"
                            disabled={isSubmitting || selectedMRDs.length === 0} 
                            onClick={() => HandleBatchAssignMaterialReadinessDocuments()}
                            style={{margin: "0 auto", height: "40px"}}>
                            <span className="material-symbols-rounded">web_traffic</span>{isSubmitting ? "Loading..." : "Assign Material Readiness Documents"}
                        </button>
                    </div>         
                </div>
            </div>
            <ToastContainer />
        </Layout>
    )
}

export default BatchAssignMaterialReadinessDocuments